import { Injectable } from '@angular/core';
import {
  DynamicEventLogContent,
  LoggerUserActionOrNavigateEventContent,
  LoggerBackEndCallEventContent,
  LoggerForwardedContent,
  LoggerPageEnteredContent, LoggerEventEnum, LoggerErrorContent, LoggerFunctionalErrorContent, LoggerLogLevelEnum, LoggerEventContent
} from '../../models/dip-registration-log-information.model';
import { HttpClient } from '@angular/common/http';

const noop = (): any => undefined;

@Injectable({
  providedIn: 'root'
})
export abstract class DiprsLoggerService {

  private customInfo: DynamicEventLogContent;
  constructor(private coreHttp: HttpClient) {
  }

  protected abstract getCustomInfo(): DynamicEventLogContent;

  info(event: LoggerEventEnum.USER_ACTION, logName: string, eventAdditionalInfo: LoggerUserActionOrNavigateEventContent): void;
  info(event: LoggerEventEnum.BACKEND_CALL, logName: string, eventAdditionalInfo: LoggerBackEndCallEventContent): void;
  info(event: LoggerEventEnum.FORWARD, logName: string, eventAdditionalInfo: LoggerForwardedContent): void;
  info(event: LoggerEventEnum.PAGE_ENTERED, logName: string, eventAdditionalInfo: LoggerPageEnteredContent): void;
  info(event: LoggerEventEnum.PAGE_EXITED | LoggerEventEnum.SESSION_EXPIRED, logName: string, eventAdditionalInfo: null): void;
  info(event: LoggerEventEnum, logName: string, eventAdditionalInfo: LoggerUserActionOrNavigateEventContent
    | LoggerBackEndCallEventContent
    | LoggerForwardedContent
    | LoggerPageEnteredContent) {
    this.spaLog(this.createSpaEventLogContent(event, logName, LoggerLogLevelEnum.INFO, eventAdditionalInfo));
  }

  debug(event: LoggerEventEnum.USER_ACTION, logName: string, eventAdditionalInfo: LoggerUserActionOrNavigateEventContent): void;
  debug(event: LoggerEventEnum.BACKEND_CALL, logName: string, eventAdditionalInfo: LoggerBackEndCallEventContent): void;
  debug(event: LoggerEventEnum.FORWARD, logName: string, eventAdditionalInfo: LoggerForwardedContent): void;
  debug(event: LoggerEventEnum.PAGE_ENTERED, logName: string, eventAdditionalInfo: LoggerPageEnteredContent): void;
  debug(event: LoggerEventEnum.PAGE_EXITED | LoggerEventEnum.SESSION_EXPIRED, logName: string, eventAdditionalInfo: null): void;
  debug(event: LoggerEventEnum, logName: string, eventAdditionalInfo: LoggerUserActionOrNavigateEventContent
    | LoggerBackEndCallEventContent
    | LoggerForwardedContent
    | LoggerPageEnteredContent) {
    this.spaLog(this.createSpaEventLogContent(event, logName, LoggerLogLevelEnum.DEBUG, eventAdditionalInfo));
  }

  warn(event: LoggerEventEnum.USER_ACTION, logName: string, eventAdditionalInfo: LoggerUserActionOrNavigateEventContent): void;
  warn(event: LoggerEventEnum.BACKEND_CALL, logName: string, eventAdditionalInfo: LoggerBackEndCallEventContent): void;
  warn(event: LoggerEventEnum.FORWARD, logName: string, eventAdditionalInfo: LoggerForwardedContent): void;
  warn(event: LoggerEventEnum.PAGE_ENTERED, logName: string, eventAdditionalInfo: LoggerPageEnteredContent): void;
  warn(event: LoggerEventEnum.PAGE_EXITED | LoggerEventEnum.SESSION_EXPIRED, logName: string, eventAdditionalInfo: null): void;
  warn(event: LoggerEventEnum, logName: string, eventAdditionalInfo: LoggerUserActionOrNavigateEventContent
    | LoggerBackEndCallEventContent
    | LoggerForwardedContent
    | LoggerPageEnteredContent) {
    this.spaLog(this.createSpaEventLogContent(event, logName, LoggerLogLevelEnum.WARN, eventAdditionalInfo));
  }

  error(event: LoggerEventEnum.ERROR, logName: string, eventAdditionalInfo: LoggerErrorContent): void;
  error(event: LoggerEventEnum.FUNCTIONAL_ERROR, logName: string, eventAdditionalInfo: LoggerFunctionalErrorContent): void;
  error(errorEvent: LoggerEventEnum, errorName: string , eventAdditionalInfo: LoggerErrorContent | LoggerFunctionalErrorContent) {
    this.spaLog(this.createSpaEventLogContent(errorEvent, errorName, LoggerLogLevelEnum.ERROR, eventAdditionalInfo));
  }

  private spaLog(spalogInfo: LoggerEventContent) {
    this.coreHttp.post<LoggerEventContent>(this.customInfo.logEndpointURL, spalogInfo).toPromise()
      .catch(noop);
  }

  private createSpaEventLogContent(
    event: LoggerEventEnum, pageId: string, logLevel: LoggerLogLevelEnum,
    eventAdditionalInfo: LoggerUserActionOrNavigateEventContent | LoggerBackEndCallEventContent | LoggerForwardedContent
      | LoggerPageEnteredContent | LoggerErrorContent | LoggerFunctionalErrorContent) {

      this.customInfo = this.getCustomInfo();

      const spaEventLogContent: LoggerEventContent = {
        eventType: this.customInfo.eventType,
        eventSubType: event,
        pageId,
        requestDomain: window.location.host,
        endPoint:  window.location.pathname,
        level: logLevel,
        userDeviceType: this.customInfo.userDeviceType,
        userLanguage: this.customInfo.userLanguage,
        eventAdditionalInfo
      };

      return spaEventLogContent;
  }
}
